import React, { useContext, useEffect, useMemo } from "react";

import t from "../../../lib/translate";
import { useIsTablet } from "../../../lib/hooks/mediaQueries";

import GeneralPageContext from "../../../templates/GeneralPageContext";

import { TeaserLayoutWrapper } from "../../../components/teaser-components/TeaserLayoutWrapper/TeaserLayoutWrapper";
import { TeaserGrid } from "../../../components/teaser-components/TeaserGrid/TeaserGrid";

import { SeminarTeaserContent } from "../type-specific-content/SeminarTeaserContent/SeminarTeaserContent";
import { VacancyTeaserContent } from "../type-specific-content/VacancyTeaserContent/VacancyTeaserContent";
import { FairTeaserContent } from "../type-specific-content/FairTeaserContent/FairTeaserContent";
import { useState } from "react";

export function StandardModelbasedTeaser({
    data: {
        anker,
        tagline,
        headline,
        semanticOfHeadline,
        semanticOfTeaserHeadline,
        teaser = [],
        background
    },
    type,
    hasLightBackground
}) {
    const { stdPages } = useContext(GeneralPageContext);
    const fairLinkText = t("fair.teaser.link.text");
    const isTablet = useIsTablet();

    const [maxVacancyElements, setMaxVacancyElements] = useState(6);

    useEffect(() => {
        if (type === "DatoCmsJobAdvertisementTeaser") {
            setMaxVacancyElements(isTablet ? 3 : 999);
        }
    }, [isTablet, type]);

    const teaserConfigurationMap = {
        DatoCmsNewsTeaser: {
            buttonText: "press.list.showAll",
            sitePath: stdPages.pageNews.url,
            sliderOnMobile: true
        },
        DatoCmsSeminarTeaser: {
            typeSpecificContent: SeminarTeaserContent,
            buttonText: "seminar.list.showAll",
            sitePath: stdPages.pageSeminar.url,
            sliderOnMobile: true
        },
        DatoCmsFairTeaser: {
            typeSpecificContent: FairTeaserContent,
            buttonText: "fair.list.showAll",
            sitePath: stdPages.pageFair.url,
            sliderOnMobile: true,
            // optional "mapping" function that can be used to customize basic teaser data
            // example: use a fallback value for "teaserTagline" for DatoCmsFairTeaser items
            mapping: ({
                teaserTagline,
                divisions = [],
                fairTeaserUrl,
                teaserUrl,
                ...item
            }) => ({
                ...item,
                teaserUrl: teaserUrl || fairTeaserUrl,
                teaserButtonLabel: fairLinkText,
                teaserTagline:
                    teaserTagline ||
                    divisions.map(({ name }) => name).join(", ")
            })
        },
        DatoCmsJobAdvertisementTeaser: {
            typeSpecificContent: VacancyTeaserContent,
            buttonText: "vacancy.list.showAll",
            // sitePath: stdPages.pageJobs.url,
            sliderOnMobile: true,
            maxElements: maxVacancyElements
        }
    };

    const {
        typeSpecificContent: TypeSpecificContent,
        sitePath: overviewPagePath,
        buttonText,
        sliderOnMobile,
        mapping = (item) => item,
        sorting = () => 0,
        maxElements
    } = teaserConfigurationMap[type];

    const teaserList = useMemo(
        () => teaser.map(mapping).sort(sorting),
        [teaser, mapping]
    );

    if (!teaserList.length) return null;

    return (
        <TeaserLayoutWrapper
            anker={anker}
            tagline={tagline}
            headline={headline}
            semanticOfHeadline={semanticOfHeadline}
            background={background}
            hasLightBackground={hasLightBackground}
            overviewPage={{
                label: t(buttonText),
                link: overviewPagePath
            }}
        >
            <TeaserGrid
                teaserList={teaserList}
                sliderOnMobile={sliderOnMobile}
                hasLightBackground={hasLightBackground}
                semanticOfTeaserHeadline={semanticOfTeaserHeadline}
                TypeSpecificContent={TypeSpecificContent}
                maxElements={maxElements}
            />
        </TeaserLayoutWrapper>
    );
}
